import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";
import { AuthorizationScheme } from "types/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

const useShouldShowSpaceAccessForUserSessions = () => {
  const { authorizationScheme } = useTypedContext(SpacesContext);
  const { loginPolicySpaceAccessV2 } = useTypedFlags();

  return loginPolicySpaceAccessV2 && authorizationScheme === AuthorizationScheme.LoginPolicies;
};

export default useShouldShowSpaceAccessForUserSessions;
